import React, { createContext, useContext, useEffect, useState } from 'react';

const TelegramContext = createContext();

export const useTelegram = () => {
    const context = useContext(TelegramContext);
    if (!context) {
        throw new Error('useTelegram must be used within TelegramProvider');
    }
    return context;
};

export const TelegramProvider = ({ children }) => {
    const [tg, setTg] = useState(null);
    const [user, setUser] = useState(null);
    const [theme, setTheme] = useState('dark');

    useEffect(() => {
        if (window.Telegram?.WebApp) {
            const telegramApp = window.Telegram.WebApp;
            setTg(telegramApp);
            
            // Получаем данные пользователя
            if (telegramApp.initDataUnsafe?.user) {
                setUser(telegramApp.initDataUnsafe.user);
            }
            
            // Определяем тему
            const colorScheme = telegramApp.colorScheme || 'dark';
            setTheme(colorScheme);
            
            // Слушаем изменения темы
            telegramApp.onEvent('themeChanged', () => {
                setTheme(telegramApp.colorScheme);
            });
        }
    }, []);

    const showAlert = (message) => {
        if (tg) {
            tg.showAlert(message);
        } else {
            alert(message);
        }
    };

    const showConfirm = (message) => {
        return new Promise((resolve) => {
            if (tg) {
                tg.showConfirm(message, resolve);
            } else {
                resolve(confirm(message));
            }
        });
    };

    const hapticFeedback = (type = 'light') => {
        try {
            if (tg?.HapticFeedback) {
                const notifTypes = ['error', 'success', 'warning'];
                const impactTypes = ['light', 'medium', 'heavy', 'rigid', 'soft'];
                if (notifTypes.includes(type)) {
                    tg.HapticFeedback.notificationOccurred(type);
                } else if (impactTypes.includes(type)) {
                    tg.HapticFeedback.impactOccurred(type);
                } else {
                    // fallback for unknown types
                    tg.HapticFeedback.impactOccurred('medium');
                }
            }
        } catch (e) {
            console.warn('HapticFeedback error:', e);
        }
    };

    const openLink = (url) => {
        if (tg) {
            tg.openLink(url);
        } else {
            window.open(url, '_blank');
        }
    };

    const close = () => {
        if (tg) {
            tg.close();
        }
    };

    const value = {
        tg,
        user,
        theme,
        showAlert,
        showConfirm,
        hapticFeedback,
        openLink,
        close,
        isTelegram: !!tg
    };

    return (
        <TelegramContext.Provider value={value}>
            {children}
        </TelegramContext.Provider>
    );
};
